import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { AppEventService } from '../../app/app-events';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Generated class for the MyNotesComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'my-notes',
  templateUrl: 'my-notes.html',
  styleUrls: ['./my-notes.scss'],
  standalone: false,
  // imports: [
  //   IonicModule,
  //   CommonModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class MyNotesComponent implements OnDestroy {

  imgSource: string;
  @Input() public notes: string;

  // 1. Define the emitter. Name MUST be 'notesChange' for [(notes)] to work automatically
  @Output() notesChange = new EventEmitter<string>();

  // 2. Helper function called when user types
  updateNotes(newValue: string) {
    this.notes = newValue;
    // 3. Emit the new value to the parent
    this.notesChange.emit(newValue);
  }

  timer: any;

  private setNotesSubscription: any;

  constructor(
    private events: AppEventService
  ) {
    this.imgSource = 'assets/svg/icon_mynotes.svg';

    this.timer = null;

    this.setNotesSubscription = (prevNotes) => {
      console.log("[my-notes] setting notes");
      this.notes = prevNotes;
    }
    this.events.subscribe("set:notes", this.setNotesSubscription);

  }

  ngOnDestroy() {
    this.events.unsubscribe("set:notes", this.setNotesSubscription);
  }

  showMyNotes_obsolete() {
    console.log("TODO: show my notes");
  }

  getItems(searchbar) {
    var q = searchbar;
    console.log(q);
    return true;
  }

  updateNotes_obsolete() {
    console.log("new note value: " + this.notes);

    if (this.timer != null) {
      console.log("timer opnieuw instellen!");
      clearTimeout(this.timer);
    }
    console.log("timer gaat lopen");
    this.timer = setTimeout(function () {
      this.postNoteUpdate();
    }.bind(this), 1000);

    //this.events.publish("update:notes", this.notes);
    //TODO: do something (publish to the analysis service)
  }

  postNoteUpdate() {
    console.log("[my-notes] PUB update:notes");
    this.events.publish("update:notes", this.notes);

  }


}
